import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { FormTemplate } from '../../../types/FormTemplate';
import { mutationKeys } from '../mutationKeys';

const updateFormTemplate = async (uuid: string | undefined, formData: FormTemplate) => {
  if (!uuid) return null;

  const response = await CustomAxios.put(`form_templates/${uuid}`, formData);
  const { data } = response;
  return data;
};

interface UseUpdateFormTemplateFormProps {
  uuid?: string;
  onSuccessCallback: () => void;
}

export function useUpdateFormTemplate({ uuid, onSuccessCallback }: UseUpdateFormTemplateFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateFormTemplate],
    mutationFn: (formData: FormTemplate) => updateFormTemplate(uuid, formData),
    onSuccess: (data: FormTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allFormTemplates, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const formTemplate: FormTemplate = err.response.data as FormTemplate;
        queryClient.setQueryData([queryKeys.allFormTemplates, formTemplate.uuid], formTemplate);
      }
    },
  });
}
